import { render, staticRenderFns } from "./addSuppliersModal.vue?vue&type=template&id=043562a9&"
import script from "./addSuppliersModal.vue?vue&type=script&lang=js&"
export * from "./addSuppliersModal.vue?vue&type=script&lang=js&"
import style0 from "./addSuppliersModal.vue?vue&type=style&index=0&id=043562a9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports